// @flow

import React from 'react'
import styled from 'styled-components'

const AmenityItem = styled.li`
  ${props =>
    props.isNotSelected
      ? `
    color: #cdc7c7;
    text-decoration: line-through;
  `
      : ''};
`

type PropTypes = {
  masterAmenities: Array<{
    name: string,
    nameText: string,
  }>,
  roomAmenities: Array<{
    name: string,
  }>,
  isOpen: boolean,
  onClickReadmore: Function,
}

export default (props: PropTypes) => {
  const { masterAmenities, roomAmenities, isOpen, onClickReadmore } = props
  const roomAmenityNames = roomAmenities.map(a => a.name)
  return (
    <section className="space-expandable space-plan__amenity">
      <h3 className="space-main__headline-big">
        {i18n.t('page.room.amenity')}
      </h3>
      <div className={`${isOpen ? '' : 'space-expandable__area'}`}>
        <div className="space-expandable__area-text">
          <ul className="row">
            {masterAmenities.map((amenity, i) => {
              const isNotSelected = !roomAmenityNames.find(
                n => n === amenity.name,
              )
              return (
                <AmenityItem
                  key={`amenity_item_${i}`}
                  className="col-xs-6 col-md-4"
                  isNotSelected={isNotSelected}
                >
                  <i className={`icon icon-spm-${amenity.name}`} />
                  {amenity.nameText}
                </AmenityItem>
              )
            })}
          </ul>
        </div>
      </div>
      {isOpen ? null : (
        <p className="space-expandable__link">
          <a href="#" className="a__underline" onClick={onClickReadmore}>
            {i18n.t('page.room.readmore')}
            <i className="fa fa-angle-down ml5" />
          </a>
        </p>
      )}
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailAmenities/index.jsx